export default function FieldWrapper({
  hint,
  error,
  visible,
  children,
  hintColor,
}) {
  let isComponentVisible =
    visible === null || visible === undefined ? true : visible;
  return (
    isComponentVisible && (
      <div className="flex flex-col items-start justify-start gap-2 w-full max-w-[420px]">
        {children}
        {hint && (
          <span
            className="font-semibold text-sm w-full max-w-[420px]"
            style={{
              color: hintColor || "#898989",
            }}
          >
            {hint}
          </span>
        )}
        {error && (
          <span className="text-[#EE0000] font-semibold text-sm w-full max-w-[420px]">
            {error}
          </span>
        )}
      </div>
    )
  );
}
